module.exports = __webpack_public_path__ + "static/alibaba-94fe1339db8814fa4f1c3d851a26f150.png";